import script from "./CollectionEditList.vue?vue&type=script&setup=true&lang=js"
export * from "./CollectionEditList.vue?vue&type=script&setup=true&lang=js"

import "./CollectionEditList.vue?vue&type=style&index=0&id=69e8a891&lang=scss"

const __exports__ = script;

export default __exports__